import React from 'react';
import { Link } from 'react-router-dom';
import { Facebook, Twitter, Instagram, Youtube, Linkedin } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-section">
          <h4>Company</h4>
          <ul>
            <li><Link to="/about">About Us</Link></li>
            <li><Link to="/support">Support</Link></li>
            <li><Link to="/careers">Careers</Link></li>
          </ul>
        </div>
        <div className="footer-section">
          <h4>Resources</h4>
          <ul>
            <li><Link to="/help">Help</Link></li>
            <li><Link to="/learn">Learn</Link></li>
            <li><Link to="/newsletter">Newsletter</Link></li>
          </ul>
        </div>
        <div className="footer-section">
          <h4>Legal</h4>
          <ul>
            <li><Link to="/privacy">Privacy Policy</Link></li>
            <li><Link to="/terms">Terms & Conditions</Link></li>
          </ul>
        </div>
        <div className="footer-section">
          <h4>Follow Us</h4>
          <div className="social-icons">
            <a href="https://facebook.com" target="_blank" rel="noopener noreferrer"><Facebook size={24} /></a>
            <a href="https://twitter.com" target="_blank" rel="noopener noreferrer"><Twitter size={24} /></a>
            <a href="https://instagram.com" target="_blank" rel="noopener noreferrer"><Instagram size={24} /></a>
            <a href="https://youtube.com" target="_blank" rel="noopener noreferrer"><Youtube size={24} /></a>
            <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer"><Linkedin size={24} /></a>
          </div>
        </div>
      </div>
      <div className="footer-bottom">
        <div className="footer-bottom-content">
          <p>&copy; {new Date().toLocaleDateString('en-CA', { timeZone: 'America/New_York'}).slice(0, 4)} Bidsig Inc. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;